package com.evoapps.evoshift.domain.model

/**
 * A place found for an address a manager typed (SH-132): OpenStreetMap's name for it
 * ("Długa 5, Główne Miasto, Gdańsk, …") and its point.
 */
data class AddressSuggestion(val label: String, val location: GeoLocation)

/** Why an address search gave no answer (SH-132). */
enum class AddressSearchFailure {
    /** Too many searches at once (the service allows one per second): try again shortly. */
    BUSY,
    /** Not a manager or the owner of the workplace. */
    NOT_ALLOWED,
    /** Offline, or the search service failed. */
    FAILED
}

class AddressSearchException(val failure: AddressSearchFailure, cause: Throwable? = null) :
    Exception("Address search failed: $failure", cause)
